import React from 'react'
import { Route, Switch } from 'react-router-dom'
import {
  App,
  LoginForm,
  Home,
  ContentsList,
  ContentsNew,
  ContentMetrics,
  TagsList,
  TagsNew,
  Tips,
  NewTip,
  Polls,
  NewPoll,
  Welcomes,
  NewWelcome,
  Events,
  NewEvent,
  Featured,
  Dock,
  Messages,
  NewMessage,
  Downloads,
  Users,
  Conditions,
  SuggestedConditions,
  Medications,
  SuggestedMedications,
} from 'containers'

import RequireAuth from 'containers/Login/RequireAuth'

const HomeAuth = RequireAuth(Home)
const ContentsListAuth = RequireAuth(ContentsList)
const ContentsNewAuth = RequireAuth(ContentsNew)
const ContentMetricsAuth = RequireAuth(ContentMetrics)
const TagsListAuth = RequireAuth(TagsList)
const TagsNewAuth = RequireAuth(TagsNew)
const TipsAuth = RequireAuth(Tips)
const NewTipAuth = RequireAuth(NewTip)
const PollsAuth = RequireAuth(Polls)
const NewPollAuth = RequireAuth(NewPoll)
const WelcomesAuth = RequireAuth(Welcomes)
const NewWelcomeAuth = RequireAuth(NewWelcome)
const EventsAuth = RequireAuth(Events)
const NewEventAuth = RequireAuth(NewEvent)
const FeaturedAuth = RequireAuth(Featured)
const DockAuth = RequireAuth(Dock)
const MessagesAuth = RequireAuth(Messages)
const NewMessageAuth = RequireAuth(NewMessage)
const DownloadsAuth = RequireAuth(Downloads)
const UsersAuth = RequireAuth(Users)
const ConditionsAuth = RequireAuth(Conditions)
const SuggestedConditionsAuth = RequireAuth(SuggestedConditions)
const MedicationsAuth = RequireAuth(Medications)
const SuggestedMedicationsAuth = RequireAuth(SuggestedMedications)

const AppSwitch = (
  <App>
    <Switch>
      <Route exact path="/login" component={LoginForm} />
      <Route exact path="/" component={HomeAuth} />

      <Route exact path="/contents" component={ContentsListAuth} />
      <Route path="/contents/new" component={ContentsNewAuth} />
      <Route path="/contents/metrics" component={ContentMetricsAuth} />
      <Route path="/contents/edit/:contentId" component={ContentsNewAuth} />

      <Route exact path="/tags" component={TagsListAuth} />
      <Route path="/tags/new" component={TagsNewAuth} />

      <Route exact path="/tips" component={TipsAuth} />
      <Route path="/tips/new" component={NewTipAuth} />
      <Route path="/tips/edit/:tipId" component={NewTipAuth} />

      <Route exact path="/polls" component={PollsAuth} />
      <Route path="/polls/new" component={NewPollAuth} />
      <Route path="/polls/edit/:pollId" component={NewPollAuth} />

      <Route exact path="/events" component={EventsAuth} />
      <Route path="/events/new" component={NewEventAuth} />
      <Route path="/events/edit/:eventId" component={NewEventAuth} />

      <Route exact path="/welcomes" component={WelcomesAuth} />
      <Route path="/welcomes/new" component={NewWelcomeAuth} />
      <Route path="/welcomes/edit/:welcomeId" component={NewWelcomeAuth} />

      <Route path="/featured/list" component={FeaturedAuth} />
      <Route path="/featured" component={DockAuth} />

      <Route exact path="/messages" component={MessagesAuth} />
      <Route path="/messages/new" component={NewMessageAuth} />
      <Route path="/messages/edit/:messageId" component={NewMessageAuth} />

      <Route path="/downloads" component={DownloadsAuth} />
      <Route path="/users" component={UsersAuth} />
      <Route exact path="/conditions" component={ConditionsAuth} />
      <Route path="/conditions/suggested" component={SuggestedConditionsAuth} />
      <Route exact path="/medications" component={MedicationsAuth} />
      <Route
        path="/medications/suggested"
        component={SuggestedMedicationsAuth}
      />
    </Switch>
  </App>
)

export default AppSwitch
